import throttle from 'qj/throttle';
window.jQuery.throttleFn = throttle;
